import type { ReactElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { Divider, useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

type TAccordionTemplate = {
  header: ReactElement;
  body: ReactElement;
  isActive: boolean;
  isEnabled?: boolean;
};

const initialAnimationState = { height: 0 };
const finalAnimationState = { height: 'auto' };

const motionConfig = {
  initial: initialAnimationState,
  animate: finalAnimationState,
  exit: initialAnimationState,
  transition: { duration: 0.3 }
};

export const DEFAULT_STYLE =
  'co-w-full co-flex co-flex-col co-rounded co-h-auto';
export const ENABLED_STYLE = `${DEFAULT_STYLE} co-bg-common-white co-border-1 co-border-gray-xxxlight`;
export const DISABLED_STYLE = `${DEFAULT_STYLE} co-border-pds-neutral-300 co-pointer-events-none !co-bg-[#E6E6E6]`;

export const AccordionTemplate = (props: TAccordionTemplate) => {
  const { header, body, isActive, isEnabled = false } = props;
  const isMobile = useMediaQuery('lg');

  const className = isEnabled ? ENABLED_STYLE : DISABLED_STYLE;

  return (
    <div className={className}>
      {header}
      {!isMobile && isActive && isEnabled && <Divider />}
      <AnimatePresence mode="wait">
        {isActive && isEnabled && (
          <motion.div
            className="co-w-full co-h-auto co-overflow-hidden co-rounded-b"
            {...motionConfig}
          >
            {body}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
